import { r as registerInstance, c as createEvent, g as getElement } from './core-6f498fd9.js';
var CsmIntersectAnchor = /** @class */ (function () {
    function CsmIntersectAnchor(hostRef) {
        registerInstance(this, hostRef);
        this.csmIntersectChange = createEvent(this, "csmIntersectChange", 7);
    }
    CsmIntersectAnchor.prototype.componentWillLoad = function () {
        var _this = this;
        this.anchorObserver = new IntersectionObserver(function (changes) { return _this.csmIntersectChange.emit(changes); }, this.options);
    };
    CsmIntersectAnchor.prototype.componentDidLoad = function () {
        this.anchorObserver.observe(this.element);
    };
    CsmIntersectAnchor.prototype.componentDidUnload = function () {
        this.anchorObserver.unobserve(this.element);
    };
    Object.defineProperty(CsmIntersectAnchor.prototype, "element", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    return CsmIntersectAnchor;
}());
export { CsmIntersectAnchor as csm_intersect_anchor };
